import axios from "../../../axios";

export function fetchNotificationList() {
  return axios.get(`/orders/notification_history/`);
}
